/**
 * product-family-options.js — BUILD v3 (dynamic columns + SKU search, 2026-08-01)
 * Handles the qty steppers, "Add Selected to Cart" (multi-line), SKU search
 * filtering, and scroll-spy for the Product Family Options table.
 * Requires no dependencies (vanilla JS). Safe to load once per page.
 */
(function () {
  /**
   * Refreshes cart count / drawer after a successful add.
   * Fetches the real cart object first — several themes (this one included)
   * define Shopify.onCartUpdate(cart) as a callback that reads cart.item_count,
   * so it must never be invoked with no arguments.
   * Every step is individually try/caught so one broken theme hook can't
   * throw and skip the others.
   */
 function refreshCartUI() {
  fetch('/cart.js', {
    headers: {
      Accept: 'application/json'
    }
  })
    .then(function (res) {
      return res.json();
    })
    .then(function (cart) {

      // Update header cart count
      document.querySelectorAll(
        '[data-cart-count], .cart-count, .header-cart-count, #cart-count, .cart-qty'
      ).forEach(function (el) {
        el.textContent = cart.item_count;
      });

      // Update theme cart drawer
      SW.collection.updateCartInfo(
        cart,
        ".cart-container .cart-wrapper .cart-inner-content"
      );

    })
    .catch(function (err) {
      console.warn('PFO: could not refresh cart UI.', err);
    });
}

  function initPFO(root) {
    var summaryEl = root.querySelector('[data-pfo-summary]');
    var addAllBtn = root.querySelector('[data-pfo-add-all]');
    var searchInput = root.querySelector('[data-pfo-search]');
    var noResultsEl = root.querySelector('[data-pfo-no-results]');

    function getInputs() {
      return Array.prototype.slice.call(root.querySelectorAll('.pfo-qty-input'));
    }

    /**
     * Formats a dollar-amount float as money. Prefers the theme's own
     * Shopify.formatMoney/money_format globals so currency/locale
     * formatting stays consistent with the rest of the site. Falls back
     * to a plain "$" prefix if those globals aren't available — verify
     * against your theme's actual currency setup if you serve non-USD
     * storefronts.
     */
    function formatMoney(amount) {
      var cents = Math.round(amount * 100);
      try {
        if (typeof window.Shopify !== 'undefined' &&
            typeof window.Shopify.formatMoney === 'function' &&
            typeof window.money_format !== 'undefined') {
          return window.Shopify.formatMoney(cents, window.money_format);
        }
      } catch (err) {
        console.warn('PFO: Shopify.formatMoney failed, using fallback formatting.', err);
      }
      return '$' + amount.toFixed(2);
    }

    function updateSummary() {
      var inputs = getInputs();
      var totalQty = 0;
      var totalLines = 0;
      var totalPrice = 0;

      inputs.forEach(function (input) {
        var qty = parseInt(input.value, 10) || 0;
        var row = input.closest('.pfo-row');
        if (qty > 0) {
          totalLines += 1;
          totalQty += qty;
          var price = parseFloat(input.getAttribute('data-price')) || 0;
          totalPrice += price * qty;
          if (row) row.classList.add('pfo-row--selected');
        } else if (row) {
          row.classList.remove('pfo-row--selected');
        }
      });

      if (summaryEl) {
        if (totalQty === 0) {
          summaryEl.innerHTML = '0 items selected';
        } else {
          summaryEl.innerHTML = totalQty + ' item' + (totalQty === 1 ? '' : 's') +
            (totalLines > 1 ? ' (' + totalLines + ' variants)' : '') +
            ' &middot; <span class="pfo-summary-total">' + formatMoney(totalPrice) + '</span>';
        }
      }
      if (addAllBtn) {
        addAllBtn.disabled = totalQty === 0;
      }
    }

    function clampInput(input) {
      var max = parseInt(input.getAttribute('data-max'), 10);
      var val = parseInt(input.value, 10);
      if (isNaN(val) || val < 0) val = 0;
      if (!isNaN(max) && max > 0 && val > max) val = max;
      input.value = val;
    }

    root.addEventListener('click', function (e) {
      var minus = e.target.closest('.pfo-qty-minus');
      var plus = e.target.closest('.pfo-qty-plus');
      if (!minus && !plus) return;

      var wrapper = e.target.closest('.pfo-qty-selector');
      var input = wrapper.querySelector('.pfo-qty-input');
      var current = parseInt(input.value, 10) || 0;

      if (minus) current = Math.max(0, current - 1);
      if (plus) current = current + 1;

      input.value = current;
      clampInput(input);
      updateSummary();
    });

    root.addEventListener('change', function (e) {
      if (!e.target.classList.contains('pfo-qty-input')) return;
      clampInput(e.target);
      updateSummary();
    });

    if (addAllBtn) {
      addAllBtn.addEventListener('click', function () {
        var items = [];
        getInputs().forEach(function (input) {
          var qty = parseInt(input.value, 10) || 0;
          if (qty > 0) {
            items.push({
              id: parseInt(input.getAttribute('data-variant-id'), 10),
              quantity: qty
            });
          }
        });

        if (items.length === 0) return;

        addAllBtn.disabled = true;
        var originalText = addAllBtn.textContent;
        addAllBtn.textContent = 'Adding…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (res) {
            if (!res.ok) return res.json().then(function (err) { throw err; });
            return res.json();
          })
          .then(function () {
            addAllBtn.textContent = 'Added ✓';
            addAllBtn.classList.add('pfo-added');
            getInputs().forEach(function (input) { input.value = 0; });
            updateSummary();

            refreshCartUI();

            setTimeout(function () {
              addAllBtn.textContent = originalText;
              addAllBtn.classList.remove('pfo-added');
            }, 2000);
          })
          .catch(function (err) {
            console.error('PFO add to cart error:', err);
            addAllBtn.textContent = 'Error — try again';
            setTimeout(function () {
              addAllBtn.textContent = originalText;
              updateSummary();
            }, 2000);
          });
      });
    }

    // SKU search — filters rows by substring match against data-sku
    // (already lowercased in Liquid). Hides a whole group when none of
    // its rows match, and shows a "no results" message when nothing on
    // the page matches at all. Does not touch already-selected
    // quantities on hidden rows, so a search-then-clear round trip
    // never loses a selection.
    if (searchInput) {
      var groups = Array.prototype.slice.call(root.querySelectorAll('[data-pfo-group]'));

      searchInput.addEventListener('input', function () {
        var term = searchInput.value.trim().toLowerCase();
        var anyVisible = false;

        groups.forEach(function (group) {
          var rows = Array.prototype.slice.call(group.querySelectorAll('[data-pfo-row]'));
          var groupHasMatch = false;

          rows.forEach(function (row) {
            var sku = row.getAttribute('data-sku') || '';
            var matches = term === '' || sku.indexOf(term) !== -1;
            row.hidden = !matches;
            if (matches) {
              groupHasMatch = true;
              anyVisible = true;
            }
          });

          group.hidden = !groupHasMatch;
        });

        if (noResultsEl) {
          noResultsEl.hidden = anyVisible || term === '';
        }
      });
    }

    // Scroll-spy: highlight the jump-nav chip for whichever group is
    // currently in view, and let clicking a chip smooth-scroll to it.
    var jumpNav = root.querySelector('[data-pfo-jumpnav]');
    if (jumpNav && 'IntersectionObserver' in window) {
      var chips = Array.prototype.slice.call(jumpNav.querySelectorAll('[data-pfo-jumpchip]'));
      var observedGroups = root.querySelectorAll('.pfo-group');

      chips.forEach(function (chip) {
        chip.addEventListener('click', function (e) {
          e.preventDefault();
          var target = document.getElementById(chip.getAttribute('data-target'));
          if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var id = entry.target.id;
            chips.forEach(function (chip) {
              chip.classList.toggle('pfo-active', chip.getAttribute('data-target') === id);
            });
          });
        },
        { rootMargin: '-30% 0px -60% 0px' }
      );

      observedGroups.forEach(function (group) { observer.observe(group); });
    }

    var toggle = root.querySelector('.pfo-heading-toggle');
    if (toggle) {
      toggle.addEventListener('click', function () {
        root.classList.toggle('pfo-collapsed');
        var icon = toggle.querySelector('.pfo-toggle-icon');
        var expanded = !root.classList.contains('pfo-collapsed');
        toggle.setAttribute('aria-expanded', expanded);
        if (icon) icon.textContent = expanded ? '–' : '+';
      });
    }

    updateSummary();
  }

  function init() {
    document.querySelectorAll('.pfo-wrapper').forEach(initPFO);

    // Above-the-fold "View Options & Add to Cart" CTA — smooth-scrolls to
    // the matching table instead of relying on default anchor jump, so it
    // doesn't land jarringly under a sticky header.
    document.querySelectorAll('[data-pfo-scroll-target]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var target = document.getElementById(btn.getAttribute('data-pfo-scroll-target'));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
